import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HotToastService } from '@ngneat/hot-toast';
import { Observable, of, Subscription } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from 'src/app/modules/auth/_services/auth.service';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { ForgetPasswordComponent } from '../forget-password/forget-password.component';
import { HospitalService } from '../_services';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  defaultAuth: any = {
    passportNo: '',
    password: '',
  };
  language: any;
  hasError: boolean;
  ErrorMessage: string;
  private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
  loginForm: UntypedFormGroup;
  forgetPasswordForm: UntypedFormGroup;

  isLoading$: Observable<boolean>;
  returnUrl: string;
  Login: boolean = true;
  ForgetPassword: boolean = false;
  MobilePattern = "(5)[0-9]{8}"
  Service:string = '';
  constructor(private translationService: TranslationService,
    private authService: AuthService,
    private router: Router,
    private modalService: NgbModal,
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private HospitalService: HospitalService,
  ) {
    this.isLoading$ = this.authService.isLoading$;
    //redirect to home if already logged in
    // if (localStorage.getItem("Service")) {
    //   this.Service = localStorage.getItem("Service");
    // }
    if (localStorage.getItem("v1Balsam-authf649ei9a5f55")) {
      
      // if (sessionStorage.getItem("DoctorId")) {
      //   let DoctorId = JSON.parse(sessionStorage.getItem("DoctorId"));
      //   let DepartmentId = JSON.parse(sessionStorage.getItem("DepartmentId"));
      //   this.router.navigate(['/portal/appointments/addappointment/' + DepartmentId + '/' + DoctorId]);
      // } else if (this.Service == 'BookAppointment')
      // {
      //   this.router.navigate(['/portal/appointments/specialties/']);
      // }
      // else {
        this.router.navigate(['/portal/dashboard']);

      //}
    }
  }

  ngOnInit(): void {
    // if (localStorage.getItem("Service")) {
    //   this.Service = localStorage.getItem("Service");
    // }
    this.language = this.translationService.getSelectedLanguage();
    this.initForm();
    this.initForgetPasswordForm();
  }
  get f() {
    return this.loginForm.controls;
  }
  get ForgetPasswordForm() {
    return this.forgetPasswordForm.controls;
  }
  initForm() {
    this.loginForm = this.fb.group({
      passportNo: [this.defaultAuth.username, Validators.required],
      password: [this.defaultAuth.password, Validators.required]
    });
  }
  initForgetPasswordForm() {
    this.forgetPasswordForm = this.fb.group({
      PassportNo: ['', Validators.required],
      Mobile: [null, [Validators.required, Validators.pattern(this.MobilePattern)]]
    });
  }
  submit() {
    this.loginForm.markAllAsTouched();
    if (!this.loginForm.valid) {
      return;
    }
    this.hasError = false;
    const loginSubscr = this.authService.login(this.f.passportNo.value, this.f.password.value).subscribe(res => {

      if (res.userId && res.userId != 0 && res.userId != null) {
        if (sessionStorage.getItem("DoctorId")) {
          let DoctorId = JSON.parse(sessionStorage.getItem("DoctorId"));
          let DepartmentId = JSON.parse(sessionStorage.getItem("DepartmentId"));
          this.router.navigate(['/portal/appointments/addappointment/' + DepartmentId + '/' + DoctorId]);
        }
        else if (this.Service == 'BookAppointment')
        {
          this.router.navigate(['/portal/appointments/specialties/']);
        }
        else {
          this.router.navigate(['/portal/dashboard']);
        }
        this.authService.hideLoader();
      }
      else if (!res.error?.isSuccess && res.error.responseCode == 404) {
        this.ErrorMessage = res.error?.message
        this.hasError = true;
      }
      else if (!res.error.isSuccess && res.error.responseCode == 500) {
        if (this.language == "ar") {
          this.ErrorMessage = "حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا";
        }
        else {
          this.ErrorMessage = "Something went wrong, try again later, please";
        }
        this.hasError = true;
      }
      else {
        if (this.language == "ar") {
          this.ErrorMessage = "رقم الهوية أو كلمة المرور غير صحيحة";
        }
        else {
          this.ErrorMessage = "Passport number or Password is incorrect";
        }
        this.hasError = true;
      }
    });
    this.unsubscribe.push(loginSubscr);
  }
  CheckAccountValid() {
    this.forgetPasswordForm.markAllAsTouched();
    if (!this.forgetPasswordForm.valid) {
      return;
    }
    this.hasError = false;
    const Subscr = this.authService.ForgetPassword(this.ForgetPasswordForm.PassportNo.value, this.ForgetPasswordForm.Mobile.value).pipe(
      catchError((errorMessage) => {
        return of(errorMessage);
      })
    ).subscribe(res => {

      if (res.data && res.isSuccess) {

        const modalRef = this.modalService.open(ForgetPasswordComponent);
        if (res.data.isGuest == true) {
          modalRef.componentInstance.PatientId = 0;
          modalRef.componentInstance.GuestId = res.data.userId;
        }
        else {
          modalRef.componentInstance.PatientId = res.data.userId;
          modalRef.componentInstance.GuestId = 0;
        }
        modalRef.componentInstance.PassportNo = this.ForgetPasswordForm.PassportNo.value;
        modalRef.componentInstance.SecretKey = res.data.otpSecretKey;
        modalRef.componentInstance.OtpCode = res.data.otp;
        this.authService.hideLoader();
        this.ChangeFormLogin();
      }
      // else if (!res.error?.error) {
      //   if (this.language == "ar") {
      //     this.ErrorMessage = "حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا";
      //   }
      //   else {
      //     this.ErrorMessage = "Something went wrong, try again later, please";
      //   }
      //   this.hasError = true;
      // }
      else if (!res.error?.isSuccess && res.error?.responseCode == 404) {
        this.ErrorMessage = res.error?.message
        this.hasError = true;
      }
      else if (!res.error?.isSuccess && res.error?.responseCode == 500) {
        if (this.language == "ar") {
          this.ErrorMessage = "حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا";
        }
        else {
          this.ErrorMessage = "Something went wrong, try again later, please";
        }
        this.hasError = true;
      }
      else {
        if (this.language == "ar") {
          this.ErrorMessage = "حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا";
        }
        else {
          this.ErrorMessage = "Something went wrong, try again later, please";
        }
        this.hasError = true;
      }
    });
    this.unsubscribe.push(Subscr);
  }
  ChangeFormForgetPassword() {
    this.Login = false;
    this.ForgetPassword = true;
    this.hasError = false;
  }
  ChangeFormLogin() {
    this.Login = true;
    this.ForgetPassword = false;
    this.hasError = false;

    // this.modalService.open(ForgetPasswordComponent);
  }
  
  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
    //sessionStorage.removeItem('Service')

  }
  // helpers for View
  isControlValid(controlName: string, FormGroup: UntypedFormGroup): boolean {
    const control = FormGroup.controls[controlName];
    return control.valid && (control.dirty || control.touched);
  }
  isControlInvalid(controlName: string, FormGroup: UntypedFormGroup): boolean {
    const control = FormGroup.controls[controlName];
    return control.invalid && (control.dirty || control.touched);
  }
  controlHasError(validation: string, controlName: string, FormGroup: UntypedFormGroup) {
    const control = FormGroup.controls[controlName];
    return control.hasError(validation) && (control.dirty || control.touched);
  }
  isControlTouched(controlName: string, FormGroup: UntypedFormGroup): boolean {
    const control = FormGroup.controls[controlName];
    return control.dirty || control.touched;
  }
}
